import 'isomorphic-fetch'
import { vlpCustomCardsEndpoint } from '~apiConfig'
import { getApiResponseInJSON, getIdToken } from '~utils'
import { ADD_VLP_CUSTOM_CARD, INITIALIZE_VLP_CUSTOM_CARD, FETCH_VLP_CUSTOM_CARDS, STORE_VLP_CUSTOM_CARD_TO_EDIT, VLP_CUSTOM_CARD_UPDATE_STATUS } from '../actionTypes'

const DEFAULT_PARAMS = { pagination: { current: 1, pageSize: 10 } }

export const fetchVlpCardsList = (params = DEFAULT_PARAMS) => async dispatch => {
  const { method, url } = vlpCustomCardsEndpoint.list
  const idToken = getIdToken()
  const apiResponse = await fetch(url, {
    headers: {
      Authorization: `Bearer ${idToken}`
    },
    method,
    body: JSON.stringify(params)
  })
    .then(async response => await getApiResponseInJSON(response))
    .catch(error => console.error(error))
  const { vlpCards: rows, vlpCardsCount: rowsCount } = apiResponse
  dispatch({
    type: FETCH_VLP_CUSTOM_CARDS,
    payload: {
      rows,
      rowsCount,
      params
    }
  })
}

export const initializeVLPCustomCard = (accessToken) => async dispatch => {
  const { method, url } = vlpCustomCardsEndpoint.new
  const idToken = getIdToken()
  const apiResponse = await fetch(url, {
    headers: {
      Authorization: `Bearer ${idToken}`,
      AccessToken: accessToken
    },
    method
  })
    .then(async response => await getApiResponseInJSON(response))
    .catch(error => console.error(error))
  const { allVenues, allFlags } = apiResponse
  dispatch({
    type: INITIALIZE_VLP_CUSTOM_CARD,
    payload: {
      venues: allVenues,
      allFlags
    }
  })
}

export const fetchVLPCustomCardById = vlpCustomCardObjectId => async dispatch => {
  const { method, url } = vlpCustomCardsEndpoint.edit(vlpCustomCardObjectId)
  const idToken = getIdToken()
  const apiResponse = await fetch(url, {
    headers: {
      Authorization: `Bearer ${idToken}`
    },
    method
  })
    .then(async response => await getApiResponseInJSON(response))
    .catch(error => console.error(error))
  console.log(apiResponse)
  dispatch({
    type: STORE_VLP_CUSTOM_CARD_TO_EDIT,
    payload: {
      allVenues: apiResponse?.allVenues,
      allFlags: apiResponse?.allFlags,
      vlpCard: apiResponse?.vlpCard
    }
  })
}

export const addVLPCustomCard = (vlpCustomCard, accessToken) => async dispatch => {
  const { method, url } = vlpCustomCardsEndpoint.add
  const idToken = getIdToken()
  await fetch(url, {
    body: JSON.stringify({ vlpCustomCard }),
    headers: {
      Authorization: `Bearer ${idToken}`,
      accessToken
    },
    method
  })
    .then(async response => await getApiResponseInJSON(response))
    .then(response => {
      const { addedVlpCard: { _id: newVLPCustomCardId }, message, success } = response
      dispatch({
        type: ADD_VLP_CUSTOM_CARD,
        payload: {
          newVLPCustomCardId,
          error: false,
          message,
          success
        }
      })
    })
    .catch((error) => {
      dispatch({
        type: ADD_VLP_CUSTOM_CARD,
        payload: {
          error: true,
          message: error.message,
          success: false
        }
      })
    })
}

export const updateVLPCustomCard = (vlpCustomCardObjectId, vlpCustomCardObject, accessToken) => async dispatch => {
  const { method, url } = vlpCustomCardsEndpoint.update(vlpCustomCardObjectId)
  const idToken = getIdToken()
  const apiResponse = await fetch(url, {
    body: JSON.stringify(vlpCustomCardObject),
    headers: {
      Authorization: `Bearer ${idToken}`,
      AccessToken: accessToken
    },
    method
  })
    .then(async response => await getApiResponseInJSON(response))
    .catch(error => ({
      message: error.message,
      success: false
    }))
  const { message, success } = apiResponse
  dispatch({
    type: VLP_CUSTOM_CARD_UPDATE_STATUS,
    payload: { message, success }
  })
}

export const resetVLPCustomCardActionStatus = () => async dispatch => {
  dispatch({
    type: VLP_CUSTOM_CARD_UPDATE_STATUS,
    payload: {
      message: '',
      success: false
    }
  })
}
